module.exports = __webpack_public_path__ + "assets/targetIcon-d574a0.svg";